export default __webpack_public_path__ + "static/media/rawdata.07c7f448.txt";